var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var CTAButtonOutlined = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  border-radius: ", ";\n  padding: 8px 16px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  transition: color ", " ease,\n    background-color ", " ease,\n    border-color ", " ease;\n  cursor: pointer;\n  svg {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n  &:disabled {\n    color: ", " !important;\n    border-color: ", " !important;\n    cursor: not-allowed;\n    &:hover {\n      color: ", " !important;\n      border-color: ", " !important;\n    }\n  }\n  &.red {\n    border-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n  &.small {\n    font-size: 1.2rem;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n  &.icon {\n    display: flex;\n    align-items: center;\n    svg {\n      max-width: 16px;\n      max-height: 16px;\n      margin-right: 3px;\n    }\n  }\n  &.extraPadding {\n    padding: 13px 22px;\n  }\n"], ["\n  color: ", ";\n  border-radius: ", ";\n  padding: 8px 16px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  transition: color ", " ease,\n    background-color ", " ease,\n    border-color ", " ease;\n  cursor: pointer;\n  svg {\n    fill: ", ";\n  }\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n  &:disabled {\n    color: ", " !important;\n    border-color: ",
    " !important;\n    cursor: not-allowed;\n    &:hover {\n      color: ", " !important;\n      border-color: ",
    " !important;\n    }\n  }\n  &.red {\n    border-color: ", ";\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n  &.small {\n    font-size: 1.2rem;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n  &.icon {\n    display: flex;\n    align-items: center;\n    svg {\n      max-width: 16px;\n      max-height: 16px;\n      margin-right: 3px;\n    }\n  }\n  &.extraPadding {\n    padding: 13px 22px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.danger.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.danger.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.danger.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.danger.color;
});
var templateObject_1;
//# sourceMappingURL=CTAButtonOutlined.js.map